import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    action: '',
    seekTo: -1,
};
const externalMediaPlayerSlice = createSlice({
    name: 'externalMediaPlayer',
    initialState,
    reducers: {
        addExternalMediaPlayerAction: (state, action) => {
            state.action = action.payload;
        },
        externalMediaPlayerSeekTo: (state, action) => {
            state.seekTo = action.payload;
        },
        resetExternalMediaPlayer: (state) => {
            state.action = '';
            state.seekTo = -1;
        },
    },
});
export const { addExternalMediaPlayerAction, externalMediaPlayerSeekTo, resetExternalMediaPlayer, } = externalMediaPlayerSlice.actions;
export default externalMediaPlayerSlice.reducer;
